// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__ZJsYD","col":"styles_col__biB0Z","fulfillmentStatus":"styles_fulfillmentStatus__1f6u0","emailCol":"styles_emailCol__2HHis"};